import React from "react";

const HcSteps = ({ ul, headline }) => {
  return (
    <div className="wp-block-kehittamo-block-hc-steps wp-block-kehittamo-block-hc bg-[#1F7AA7] bg-[url('/wp-content/themes/muotolevy/dist/images/swirl.svg')] bg-right-bottom bg-no-repeat">
      <div className="">
        <h2 className="m-0 p-0 text-white text-center text-md mb-4">
          {headline}
        </h2>
        <div className="flex flex-col xl:flex-row justify-center gap-6 xl:gap-8">
          {ul.map(({ headline, body }, index) => {
            return (
              <div key={index} className="flex flex-col gap-4 items-center">
                <div className="relative">
                  <svg
                    className="mx-auto"
                    height="80px"
                    width="80px"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 512 512"
                    xmlSpace="preserve"
                  >
                    <polygon
                      fill="#1F7AA7"
                      points="41.356,374.401 41.356,137.607 256,18.652 470.644,137.607 470.644,374.401 256,493.357"
                    />
                    <path
                      fill="#FFFFFF"
                      d="M256,37.303l198.333,109.919v217.555L256,474.697L57.667,364.778V147.222L256,37.303 M256,0
	L25.045,128v256L256,512l230.955-128V128L256,0z"
                    />
                  </svg>
                  <p className="absolute left-1/2 top-1/2 m-0 -translate-x-1/2 -translate-y-1/2 transform p-0 text-2xl font-bold text-white xl:text-4xl">
                    {index + 1}
                  </p>
                </div>
                <h3 className="m-0 max-w-96 p-0 text-center uppercase text-white xl:text-2xl">
                  {headline}
                </h3>
                <p className="max-w-96 font-medium m-0 p-0 text-white text-center xl:text-base">
                  {body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HcSteps;
